var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "sidebarWindow bigSidebarWindow" }, [
    _c("div", { staticClass: "sidebarWindowTitle" }, [
      _c("span", [_vm._v(_vm._s(_vm.$t("Search")))]),
      _vm._v(" "),
      _c(
        "span",
        { staticClass: "closeSidebarArrow", on: { click: _vm.closeSearch } },
        [_c("CloseWindowSVG")],
        1
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      [
        _c("app-toggle-buttons", {
          attrs: { buttons: _vm.toggleButtons, value: _vm.filterOption },
          on: {
            input: function($event) {
              _vm.filterOption = $event
            }
          }
        }),
        _vm._v(" "),
        _vm.filterOption === "other"
          ? _c(
              "div",
              { staticClass: "mx-auto mt-3 input-field-container" },
              [
                _c("treeselect", {
                  attrs: {
                    options: _vm.typeOptions,
                    normalizer: _vm.objectTypeNormalizer,
                    "value-consists-of": "LEAF_PRIORITY",
                    "disable-branch-nodes": true,
                    "default-expand-level": 1,
                    required: ""
                  },
                  model: {
                    value: _vm.selectedLayer,
                    callback: function($$v) {
                      _vm.selectedLayer = $$v
                    },
                    expression: "selectedLayer"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.filterOption === "other"
          ? _c(
              "div",
              { staticClass: "mx-auto mt-2 input-field-container" },
              [
                _c("treeselect", {
                  attrs: {
                    "value-consists-of": "LEAF_PRIORITY",
                    "default-expand-level": 1,
                    options: _vm.attributeOptions,
                    "load-options": _vm.requestLayerAttributes,
                    "auto-load-root-options": true,
                    "disable-branch-nodes": true,
                    defaultExpandLevel: 0,
                    disabled: !_vm.selectedLayer,
                    required: ""
                  },
                  model: {
                    value: _vm.selectedAttributes,
                    callback: function($$v) {
                      _vm.selectedAttributes = $$v
                    },
                    expression: "selectedAttributes"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "search-input-container" },
          [
            _c(
              "v-text-field",
              {
                attrs: {
                  label: _vm.$t("Search"),
                  type: "text",
                  clearable: "",
                  disabled: _vm.disableSearch,
                  solo: "",
                  loading: _vm.loading,
                  messages: _vm.disableSearch
                    ? "Select Layer and Attribute..."
                    : ""
                },
                on: { input: _vm.search },
                model: {
                  value: _vm.searchWord,
                  callback: function($$v) {
                    _vm.searchWord = $$v
                  },
                  expression: "searchWord"
                }
              },
              [
                _c("v-icon", { attrs: { slot: "append" }, slot: "append" }, [
                  _vm._v("\n            search\n          ")
                ])
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "search-container" }, [
      _c(
        "div",
        {
          staticClass: "search-content scroll-fire-fox",
          attrs: { id: "scroll-bar" }
        },
        [
          _vm._l(_vm.places, function(place) {
            return _c(
              "div",
              {
                key: place.index,
                staticClass: "layer-object-content",
                on: {
                  click: function($event) {
                    return _vm.centerMapFromCoordinatesForm(
                      place.geometry.location.lng,
                      place.geometry.location.lat
                    )
                  }
                }
              },
              [
                _c("div", { staticClass: "object-content-place" }, [
                  _c("span", { staticClass: "layer-label-address" }, [
                    _vm._v(_vm._s(place.name))
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "object-content-place-info" }, [
                    _c("h4", [_vm._v("Address:")]),
                    _vm._v(" "),
                    _c("span", { staticStyle: { width: "160px" } }, [
                      _vm._v(" " + _vm._s(place.formatted_address))
                    ])
                  ])
                ])
              ]
            )
          }),
          _vm._v(" "),
          _vm.filterOption === "other" && _vm.searchList.length > 0
            ? _c(
                "div",
                { staticClass: "layer-object-content" },
                [
                  _c("div", { staticClass: "layer-label" }, [
                    _vm._v(_vm._s(_vm.$t(_vm.selectedLayer)))
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.searchList, function(objects, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "object-content",
                        on: {
                          click: function($event) {
                            return _vm.centerObjectOnMap(objects.object)
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "object-id" }, [
                          _c("span", { staticClass: "object-content-label" }, [
                            _vm._v(_vm._s(_vm.$t("ID")))
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.getObjectField(
                                  objects.object,
                                  objects.prefix,
                                  "id"
                                )
                              )
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _vm.selectedLayer !== "fc_building"
                          ? _c(
                              "div",
                              { staticClass: "object-label" },
                              [
                                _c(
                                  "span",
                                  { staticClass: "object-content-label" },
                                  [
                                    _vm._v(
                                      " " + _vm._s(_vm.$tc("Label", 1)) + ": "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-tooltip",
                                  {
                                    attrs: { bottom: "" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function(ref) {
                                            var on = ref.on
                                            var attrs = ref.attrs
                                            return [
                                              _c(
                                                "span",
                                                _vm._g(
                                                  _vm._b(
                                                    {},
                                                    "span",
                                                    attrs,
                                                    false
                                                  ),
                                                  on
                                                ),
                                                [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(
                                                        _vm.getObjectField(
                                                          objects.object,
                                                          objects.prefix,
                                                          "label"
                                                        )
                                                      ) +
                                                      "\n                "
                                                  )
                                                ]
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  },
                                  [
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.getObjectField(
                                            objects.object,
                                            objects.prefix,
                                            "label"
                                          )
                                        )
                                      )
                                    ])
                                  ]
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ]
                    )
                  })
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.typeObjectsFound, function(layer) {
            return _vm.filterOption !== "other" && layer.objects.length > 0
              ? _c(
                  "div",
                  { key: layer.layer, staticClass: "layer-object-content" },
                  [
                    _c("div", { staticClass: "layer-label" }, [
                      _vm._v(_vm._s(_vm.$t(layer.layer)))
                    ]),
                    _vm._v(" "),
                    _vm._l(layer.objects, function(object, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "object-content",
                          on: {
                            click: function($event) {
                              return _vm.centerObjectOnMap(object)
                            }
                          }
                        },
                        [
                          _c("div", { staticClass: "object-id" }, [
                            _c(
                              "span",
                              { staticClass: "object-content-label" },
                              [_vm._v(_vm._s(_vm.$t("ID")))]
                            ),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.getObjectField(object, layer.prefix, "id")
                                )
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          layer.layer !== "fc_building"
                            ? _c(
                                "div",
                                { staticClass: "object-label" },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "object-content-label" },
                                    [
                                      _vm._v(
                                        " " + _vm._s(_vm.$tc("Label", 1)) + ": "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-tooltip",
                                    {
                                      attrs: { bottom: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function(ref) {
                                              var on = ref.on
                                              var attrs = ref.attrs
                                              return [
                                                _c(
                                                  "span",
                                                  _vm._g(
                                                    _vm._b(
                                                      {},
                                                      "span",
                                                      attrs,
                                                      false
                                                    ),
                                                    on
                                                  ),
                                                  [
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(
                                                          _vm.getObjectField(
                                                            object,
                                                            layer.prefix,
                                                            "label"
                                                          )
                                                        ) +
                                                        "\n                "
                                                    )
                                                  ]
                                                )
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    },
                                    [
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.getObjectField(
                                              object,
                                              layer.prefix,
                                              "label"
                                            )
                                          )
                                        )
                                      ])
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ]
                      )
                    })
                  ],
                  2
                )
              : _vm._e()
          }),
          _vm._v(" "),
          _vm.noResultsFound
            ? _c("span", { staticClass: "search-content-no-results" }, [
                _vm._v("\n        " + _vm._s(_vm.$t("NoResults")) + "\n      ")
              ])
            : _vm._e()
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-242998fd", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-242998fd","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/SideBar/SidebarWindows/Search.vue
// module id = null
// module chunks = 